import { RootState } from '../store';

export const getTeam = (state: RootState) => state.team;

export const getActivePlayer = (state: RootState) => state.team.activePlayer;
export const getInGame = (state: RootState) => state.team.inGame;
